// extracted by mini-css-extract-plugin
export var container = "Item-module--container--2330E";
export var container__text = "Item-module--container__text--3r7um";